<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <vx-card class="mt-6" :title="title">
    <div class="vx-row">
      <div
        class="vx-col w-1/3"
        v-for="(item, index) of drafts"
        :key="index"
        @dblclick="
          (e) => {
            copyId(e, item);
          }
        "
      >
        <vx-card class="mb-2" :name="'status' + index">
          <span
            v-if="item.step <= 1"
            class="top-0 right-0 mt-2 mr-4 absolute cursor-pointer"
            @click="showEdit(item)"
          >
            <feather-icon icon="EditIcon"></feather-icon>
          </span>
          <p>نام فروشگاه:</p>
          <h5>
            <span style="vertical-align: middle">
              <feather-icon
                :title="DraftType[item.draftType].title"
                :icon="DraftType[item.draftType].icon"
                :svgClasses="[`h-5 w-6 stroke-current `]"
              ></feather-icon>
            </span>
            {{ item.shopName }}
          </h5>
          <p class="mt-3">وبسایت:</p>
          <h5>{{ item.websiteAddress }}</h5>
          <p class="mt-3">تاریخ ایجاد درگاه:</p>
          <h5>
            {{ $moment(item.creationTime).format("HH:mm:ss jYYYY/jM/jD") }}
          </h5>
        </vx-card>
        <tippy :to="'status' + index" arrow>
          <time-line :step="step(item)" />
        </tippy>
      </div>
      <div class="vx-col w-1/3">
        <vx-card class="mb-2">
          <p class="text-center cursor-pointer" @click="showCreate">
            <span>درخواست جدید</span>
          </p>
        </vx-card>
      </div>
    </div>
    <gateway-create-or-edit ref="GatewayCreateOrEdit1" @success="getDrafts" />
  </vx-card>
</template>
<style lang="scss">
</style>
<script>
import GatewayCreateOrEdit from "./GatewayCreateOrEdit.vue";
import { CreateEditMode, DraftType } from "@/enums.js";
import TimeLine from "./register/TimeLine.vue";
export default {
  name: "gateway-requests",
  props: {},
  components: {
    GatewayCreateOrEdit,
    CreateEditMode,
    "time-line": TimeLine,
  },
  data() {
    return {
      DraftType,
      drafts: [],
      businessCategoryId: 0,
    };
  },
  computed: {
    title() {
      return this.$route.query.mid
        ? `درخواست‌ها "${this.$route.query.fullName}"`
        : "درخواست‌ها";
    },
  },
  methods: {
    getDrafts() {
      let payload = {
        params: {
          MaxResultCount: 999,
          SkipCount: 0,
          IsArchived: false,
        },
      };
      let loading = this.$vs.loading();
      let path = "";
      if (this.$route.query.mid) {
        path = "/api/services/app/Gateway/GetRequestGateways";
        payload.params.merchantId = this.$route.query.mid;
      } else {
        path = "/api/services/app/Gateway/GetRequestGateways_CurrentUser";
      }
      this.$http
        .get(path, payload)
        .then((response) => {
          this.drafts = response.data.result.items
            .filter((x) => x.state != 14)
            .sort((a, b) => (a.creationTime < b.creationTime ? -1 : 1));
          //this.totalCount = response.data.result.totalCount;
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http
    },
    showCreate() {
      this.$refs.GatewayCreateOrEdit1.show();
    },
    showEdit(item) {
      this.$refs.GatewayCreateOrEdit1.show(item.shopName, item.requestId);
    },
    step(r1) {
      //not exist request
      if (!r1) return 0;
      //psp
      if (r1.step == 1) {
        switch (r1.state) {
          //inrequest
          case 0:
            return 0;
          //request
          case 1:
            return 1;
          //incomplate && complate
          case 2:
          case 3:
            return 2;
          default:
            return 3;
        }
      }
      // not psp
      else {
        //Approved
        if (r1.state == 14) return 5;
        else return 4;
      }
      return 1;
    },
    copyId(e,item) {
      if (e.ctrlKey) {
        this.$helper.copy(JSON.stringify(item, null, 4), "ID کپی شد");
      } else {
        this.$helper.copy(item.requestId, "ID کپی شد");
      }
    },
  },
  mounted() {
    this.getDrafts();
  },
};
</script>
